import React, { useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { AuthContext } from '../hooks/context/authContext';
import { validateLogin } from '../consumers/backendConsumer';

const SSOLogin = () => {
  const { dispatch } = useContext(AuthContext);
  const history = useHistory();

  useEffect(() => {
    const checkUserSession = async () => {
      try {        
        const cognitoUser = await Auth.currentAuthenticatedUser();
        const session = cognitoUser.getSignInUserSession();
        if (!session) {
          throw new Error("No se pudo obtener la sesión del usuario de Cognito.");
        }
        const idToken = session.getIdToken();
        const attributes = idToken.payload;
        const email = attributes.email;
        const photo = attributes.picture || '';
        if (!email) {
          throw new Error("El atributo 'email' no se encontró en el payload del IdToken.");
        }
        const response = await validateLogin(email, photo);        
        if (response.status === 200) {
          
          dispatch({
            type: 'LOGIN',
            payload: {
              user: {
                email: response.data.data.Email,
                id_usuario: response.data.data.IdUsuario,
                id_empleado: response.data.data.IdEmpleado,
                name: response.data.data.Nombre,
                fullName: response.data.data.NombreCompleto,
                photo: response.data.data.ProfileImageUrl,
              },
              token: response.data.data.AuthToken,
              isLoggedIn: true,
              role: response.data.data.Roles,
              roleIds: response.data.data.IdRoles,
              terms: response.data.data.showTermsMessage,
              cookies: response.data.data.showCookiesMessage,
              cookiesMessage: response.data.data.CookiesMessage,
              isInterno: response.data.data.EsInterno
            },
          });
          history.replace('/');
        } else {
          console.error('[SSOLogin] Falló la validación del backend:', response);
          Auth.federatedSignIn();
        }
      } catch (error) {
        console.error('❌ [SSOLogin] Error en el proceso de verificación de sesión:', error);
        Auth.federatedSignIn();
      }
    };

    checkUserSession();
  }, [dispatch, history]);

  return <div>Verificando sesión con SSO...</div>;
};

export default SSOLogin;